import ScrollToTopLink from "../../ScrollToTopLink";

const Image = ({ concert: { id, img, title } }) => {
  return (
    <ScrollToTopLink to={`/concerts/${id}`} className="special_hover">
      {/* <!-- image format 4:3 (800x600) Gsquare BIG AD --> */}
      <img src={img} alt={title} className="img-fluid hoverzoom" />
    </ScrollToTopLink>
  );
};

export default Image;
